/** Сообщение при 401: клиент уже уводит на /login. */
export function unauthorizedMessage(): string {
  return "Сессия истекла. Войдите снова.";
}
